export const formatSocialSecurityNumber = function (ssn) {
  if (ssn.length <= 4) return ssn;
  return ssn.slice(0, -4) + '-' + ssn.slice(-4);
};
